const apiBase = '/api/v1/edge';

export enum Actions {
  GET_EDGE_CONFIG_FILE_LOADING = '@edge_devices/GET_EDGE_CONFIG_FILE_LOADING',
  GET_EDGE_CONFIG_FILE_SUCCESS = '@edge_devices/GET_EDGE_CONFIG_FILE_SUCCES',
  GET_EDGE_CONFIG_FILE_ERROR = '@edge_devices/GET_EDGE_CONFIG_FILE_ERROR',
}

export const getEdgeConfigFileBySerialNumber = (serialNumber: string) => ({
  type: 'API_GET',
  path: `${apiBase}/config/by-serial-number/${serialNumber}/preview`,
  success: { type: Actions.GET_EDGE_CONFIG_FILE_SUCCESS, serialNumber },
  error: { type: Actions.GET_EDGE_CONFIG_FILE_ERROR, serialNumber },
  loading: { type: Actions.GET_EDGE_CONFIG_FILE_LOADING, serialNumber },
});
